import { useMobile } from '@api/services/hooks/useMobile';
import { getChannelsStore } from '@api/store/channels/actions';
import { SimplePopoverPlainOption, Typography } from '@dev/ee-components';
import { map, isEmpty } from 'lodash-es';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
/**
 *
 * @returns object will all channels in given time range
 */

export const useChannelPopoverOptions = (searchPhrase: string): SimplePopoverPlainOption[] => {
    const { t } = useTranslation();
    const isMobile = useMobile();
    const { channels, loading } = useSelector(getChannelsStore);
    const channelsList = [];
    map(channels, (channel): void => {
        if (channel.Name) {
            channelsList.push({ value: channel.Name, label: channel.Name, key: channel.Name, borderBottom: false });
        }
    });
    const search: any = isMobile ? [] : [{ value: 'search', label: 'search' }];

    if (isEmpty(channelsList) || (loading && searchPhrase && isEmpty(channelsList))) {
        return [
            ...search,
            ...(!loading
                ? [
                      {
                          label: (
                              <Typography variant="body1" bodyVariant="disabled">
                                  {t('noresults')}
                              </Typography>
                          ),
                          disabled: true,
                          value: 0,
                      },
                  ]
                : []),
        ];
    }

    return [...search, { value: 'all', label: t('all'), borderBottom: true, key: 'all' }, ...channelsList];
};
